<template>
  <div class="TaskEdit">
    <CorrectPolyPhoneModal
        ref="CorrectPolyPhoneModal"
        @refreshInputVal="refreshInputVal"
        :inputValArr="inputValArr"
    ></CorrectPolyPhoneModal>
    <el-dialog
        :title="title"
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="30%"
        style="min-width: 500px"
    >
      <el-form
          ref="form"
          :model="formData"
          :rules="rules"
          size="mini"
          label-width="90px"
      >
        <el-form-item label="标题:" prop="audioText">
          <AppSsmlEditor
              ref="audioTextEdit"
              :type="'audioText'"
              :audioText="formData.material.audioText"
              @handleChangeTitleAudio="handleChangeTitleAudio"
          >
          </AppSsmlEditor>
        </el-form-item>
        <div class="changeTitleTypeBox">
          <div>
            <span>声音属性：</span>
            <el-radio-group v-model="formData.material.voice">
              <el-radio
                  v-for="item in humanOption"
                  :key="item.value"
                  :label="item.value"
                  :disabled="creatAudioLoading"
              >
                {{ item.label }}
              </el-radio>
            </el-radio-group>
            <div>
              <div style="margin-top: 15px; margin-bottom: 15px">
                <span>播放速度： </span>
                <el-radio-group v-model="formData.material.speechRate">
                  <el-radio
                      v-for="item in rateArr"
                      :key="item.value"
                      :label="item.value"
                      :disabled="creatAudioLoading"
                  >{{ item.label }}
                  </el-radio>
                </el-radio-group>
              </div>
              <div
                  v-if="formData.material.materialUrl"
                  style="
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                "
              >
                <div>
                  <audio
                      :src="formData.material.materialUrl"
                      :loop="false"
                      controls
                      preload="auto"
                      controlsList="nodownload noplaybackrate"
                      ref="audioRef"
                  ></audio>
                </div>
                <div>
                  <el-button
                      size="mini"
                      type="primary"
                      @click="deleteTitleAudio"
                  >
                    清除音频
                  </el-button>
                </div>
              </div>
            </div>
          </div>
          <el-button
              size="mini"
              type="primary"
              @click="handleTitleAudioPolyPhone"
          >
            多音字
          </el-button>
          <el-button
              size="mini"
              type="primary"
              :loading="creatAudioLoading"
              @click="handleTitleAudio"
          >
            生成音频
          </el-button>
          <!--          <el-upload-->
          <!--              v-loading="loading"-->
          <!--              element-loading-text="上传中，请勿操作"-->
          <!--              element-loading-spinner="el-icon-loading"-->
          <!--              element-loading-background="rgba(0, 0, 0, 0.8)"-->
          <!--              drag-->
          <!--              action="#"-->
          <!--              :auto-upload="false"-->
          <!--              :before-upload="beforeUploadFile"-->
          <!--              :on-change="handleFileChange"-->
          <!--          >-->
          <!--            <i class="el-icon-upload"></i>-->
          <!--            <div>-->
          <!--              <el-button class="btn" size="mini" type="primary" slot="trigger"-->
          <!--              >上传文件-->
          <!--              </el-button>-->
          <!--            </div>-->
          <!--          </el-upload>-->
        </div>
      </el-form>

      <div class="footer">
        <div>
          <el-button @click="handleCancel">取消</el-button>
        </div>
        <div>
          <el-button type="primary" @click="handleSave">保存</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import AppSsmlEditor from "@/pages/MyOutLine/SsmlEditor.vue";
import CorrectPolyPhoneModal from "@/pages/MyOutLine/CorrectPolyPhoneModal.vue";
import wikiCenter from "@/api/wikiCenter";

export default {
  name: "TaskEdit",
  components: {CorrectPolyPhoneModal, AppSsmlEditor},
  props: {},
  data() {
    return {
      creatAudioLoading: false,
      loading: false,
      inputValArr: [],
      formData: {
        id: null,
        name: null,
        parentId: null,
        assistRoleId: null,
        attachDataList: [],
        directFlag: null,
        currentId: null,
        material: {
          materialId: null,
          materialUrl: null,
          filename: null,
          type: null,
          audioText: null,
          audioSsmlText: null,
          duration: null,
          voice: "zhiyuan",
          speechRate: 1.0,
        },
      },
      rules: {
        audioText: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur"],
          },
        ],
      },
      rateArr: [
        {
          label: "慢",
          value: 0.8,
        },
        {
          label: "正常",
          value: 1.0,
        },
        {
          label: "快",
          value: 1.2,
        },
      ],
      humanOption: [
        {
          label: "老师",
          value: "zhiyuan",
        },
        {
          label: "学生",
          value: "zhigui",
        },
        {
          label: "标准女生",
          value: "sijia",
        },
        {
          label: "沉稳男生",
          value: "stanley",
        },
      ],
    };
  },
  computed: {
    ...mapState("courseCenter", ["audioDetail"]),
    ...mapState("tenant", ["ossUploadObj"]),
    ...mapState("taskCenter", ["editNode", "type", "assistRoleId", "taskList"]),
    visible: {
      get() {
        return this.$store.state.taskCenter.taskEditVisible;
      },
      set(value) {
        this.$store.commit("taskCenter/setData", {
          key: "taskEditVisible",
          value,
        });
      },
    },
    title: {
      get() {
        if (this.type === "edit") {
          return "编辑任务";
        }
        return "新建任务";
      },
    },
  },
  watch: {
    visible: {
      handler(value) {
        if (!value) return;
        if (this.type === "edit" && this.editNode.data) {
          this.formData = {...this.editNode.data};
          this.formData.material = {...this.editNode.data.material};
        } else
          this.formData = {
            id: null,
            name: null,
            parentId: null,
            assistRoleId: null,
            attachDataList: [],
            directFlag: null,
            currentId: null,
            material: {
              materialId: null,
              materialUrl: null,
              filename: null,
              type: null,
              audioText: null,
              audioSsmlText: null,
              duration: null,
              voice: "zhiyuan",
              speechRate: 1.0,
            },
          };
      },
    },
  },
  methods: {
    ...mapMutations("courseCenter", ["setData"]),
    ...mapActions("courseCenter", ["getAudioUrl"]),
    ...mapActions("tenant", ["generalUploadUrl"]),
    handleCancel() {
      this.visible = false;
    },
    mounted() {
    },
    async handleSave() {
      let _self = this;

      if (!_self.formData.material.audioText) {
        _self.$message.warning("请填写标题");
        return;
      }
      if (!_self.formData.material.filename) {
        _self.$message.warning("请为标题生成音频");
        return;
      }
      let audioText = this.convertToObjects(_self.formData.material.audioText)
          .flatMap((params) => params["cha"])
          .join("");
      if (audioText !== this.formData.name) {
        _self.$message.warning("请为标题重新生成音频");
        return;
      }

      let type = _self.type;
      let currentNode = _self.editNode;
      _self.formData.assistRoleId = _self.assistRoleId;

      if (type === "addBelow") _self.formData.directFlag = 0;
      else if (type === "addAfter") _self.formData.directFlag = 1;
      else _self.formData.directFlag = null;
      if (type === "subMenu") _self.formData.parentId = currentNode?.key;
      else _self.formData.parentId = currentNode?.parent?.key;

      _self.formData.currentId = currentNode?.key;

      let res = await wikiCenter.saveAssistTask(_self.formData);
      let appendAssistTask = res.data;
      appendAssistTask.children = [];
      if (_self.formData.directFlag !== null) {
        let parent = currentNode.parent;
        let reference = {};
        if (parent) {
          if (parent.data.children) {
            reference.children = parent.data.children;
          } else {
            reference.children = parent.data;
          }
        } else {
          reference.children = _self.taskList;
        }

        let indexOf = reference.children.indexOf(currentNode.data);
        if (type === "addAfter") {
          indexOf++;
        }
        reference.children.splice(indexOf, 0, appendAssistTask);
      } else {
        if (type === "parentMenu") {
          if (!currentNode?.id) {
            _self.taskList.push(appendAssistTask);
          } else {
            let parent = currentNode.parent;
            parent.data.children.push(appendAssistTask);
          }
        } else if (type === "subMenu") {
          currentNode.data.children.push(appendAssistTask);
        } else if (type === "edit") {
          currentNode.data.name = appendAssistTask.name;
          currentNode.data.material = {...appendAssistTask.material};
        }
      }
      _self.visible = false;
    },
    beforeUploadFile(file) {
      const supportList = ["doc", "docx", "xls", "xlsx", "pdf"];
      if (file.name.endsWith(supportList)) {
        this.$message.error("上传文件仅支持" + supportList.join("，") + "格式");
        return false; // 终止上传
      }
    },
    async handleFileChange(file) {
      this.loading = true;
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      // this.form.avatar = this.ossUploadObj.filename
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      await this.$axios({
        url: this.ossUploadObj.url,
        withCredentials: false,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
          .then((res) => {
            console.log(res);
            this.fileUrl = URL.createObjectURL(file.raw);
            this.formData.material.filename = this.ossUploadObj.filename;
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error("上传失败，请重新上传");
            this.fileUrl = "";
            console.log(e);
          });
    },
    handleChangeTitleAudio(val) {
      this.formData.material.audioText = val;
    },
    refreshInputVal(audioText) {
      this.formData.material.audioText = audioText;
      this.$refs.audioTextEdit.blurEditor();

      this.$nextTick(() => {
        this.disabledEdit();
      });
    },
    disabledEdit() {
      let paragraphs = document.querySelectorAll("p");
      paragraphs.forEach(function (paragraph) {
        let strongArr = paragraph.querySelectorAll("strong");
        strongArr.forEach(function (strong) {
          if (getComputedStyle(strong).color === "rgb(16, 104, 156)") {
            strong.setAttribute("contenteditable", "false");
          }
        });
      });
      this.$forceUpdate();
    },
    deleteTitleAudio() {
      this.$confirm("请确认是否要清除当前音频内容?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            this.formData.material.materialUrl = "";
            this.formData.material.materialId = null;
            this.formData.material.duration = null;
            this.formData.material.filename = "";
            this.formData.material.audioText = "";
            this.formData.material.audioSsmlText = "";
            this.$forceUpdate();
          })
          .catch(() => {
          });
    },
    async handleTitleAudio() {
      let material = this.formData.material;
      const audioText = material.audioText;
      this.inputValArr = this.convertToObjects(audioText);
      if (this.inputValArr.length > 300) {
        return;
      }
      this.formData.name = this.inputValArr
          .flatMap((params) => params["cha"])
          .join("");
      this.creatAudioLoading = true;
      if (!audioText) {
        this.$message.warning("当前题干为空,不支持转音频");
        this.creatAudioLoading = false;
        return;
      }
      material.audioSsmlText = this.creatSsmlText(audioText);
      if (!material.audioSsmlText) {
        this.$message.warning("当前题干为空,不支持转音频");
        this.creatAudioLoading = false;
        return;
      }
      await this.getAudioUrl({
        text: material.audioSsmlText,
        speechRate: material.speechRate,
        voice: material.voice,
      });
      // 媒体名称
      material.filename = this.audioDetail.filename;
      // 媒体ID
      material.materialId = this.audioDetail.id;
      // 音频时长
      const audio = document.createElement("video");
      audio.src = this.audioDetail.url;
      audio.addEventListener("loadedmetadata", () => {
        if (Math.floor(audio.duration) === 0) {
          material.duration = 1;
        } else {
          material.duration = Math.floor(audio.duration);
        }
      });
      // 媒体类型
      material.type = this.audioDetail.mimeType;
      // 媒体url
      material.materialUrl = this.audioDetail.url;
      this.creatAudioLoading = false;
    },
    handleTitleAudioPolyPhone() {
      const inputVal = this.formData.material.audioText;
      this.inputValArr = this.convertToObjects(inputVal);
      if (this.inputValArr.length < 1 || this.inputValArr.length > 300) {
        return;
      }
      this.$refs.CorrectPolyPhoneModal.visible = true;
    },
    convertToObjects(inputVal) {
      const objects = [];
      if (!inputVal) {
        return objects;
      }
      const regex = /(<strong.*?>.*?<\/strong>)|./g;
      const result = inputVal.match(regex);
      var newResult = [];
      for (let i = 0; i < result.length; i++) {
        if (result[i].trim().length > 1) {
          if (!result[i].includes("color: rgb(16, 104, 156)")) {
            const div = document.createElement("div");
            div.innerHTML = result[i];
            let text = div.textContent || div.innerText;
            newResult.push(text);
          } else {
            const div = document.createElement("div");
            div.innerHTML = result[i];
            let text = div.textContent || div.innerText;
            newResult.push("{{{" + text + "}}}");
          }
        } else {
          newResult.push(result[i]);
        }
      }
      const str = newResult.join("");
      const div = document.createElement("div");
      div.innerHTML = str;
      let newStr = div.textContent || div.innerText;
      const regex2 = /({{{.*?}}})|./g;
      const result2 = newStr.match(regex2);
      for (let i = 0; i < result2.length; i++) {
        const item = result2[i];
        if (item.length > 1) {
          const regex = /\{\{\{(.+?)\}\}\}/g;
          const match = item.replace(regex, "$1");
          if (match?.length >= 2) {
            const extractedText = match.trim();
            const cha = extractedText.split("]")[1];
            const pinyin = extractedText.split("]")[0].split("[")[1];
            objects.push({cha: cha, pinyin: pinyin});
          }
        } else {
          objects.push({cha: item, pinyin: ""});
        }
      }
      return objects;
    },
    creatSsmlText(val) {
      const characterArr = this.convertToObjects(val);
      if (characterArr.length < 1) {
        return "";
      }
      const ssmlText = characterArr
          .map((item) => {
            if (item.pinyin !== "") {
              return `<phoneme alphabet='py' ph='${item.pinyin}'>${item.cha}</phoneme>`;
            } else {
              return item.cha;
            }
          })
          .join("");
      return "<speak>" + ssmlText + "</speak>";
    },
  },
};
</script>

<style lang="scss" scoped>
.TaskEdit {
  ::v-deep .ql-editor {
    height: 60px !important;
  }
}

.TaskEdit {
  ::v-deep {
    .el-upload-dragger {
      width: 150px;
      height: 100px;
    }

    .el-icon-upload {
      margin: 5px 0 5px;
    }
  }
}

.footer {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 20px;
}
</style>
